var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersCard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63600",
    "data-name": "Group 63600",
    transform: "translate(-1527.5 -374.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24443",
    "data-name": "Rectangle 24443",
    width: 66,
    height: 66,
    rx: 10,
    transform: "translate(1527.5 374.648)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Handshake",
    transform: "translate(1533.087 378.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75404",
    "data-name": "Path 75404",
    d: "M8.871,34.444a.855.855,0,0,1-.389-.093L2.008,31.016a.849.849,0,0,1-.369-1.14L9.245,14.853a.849.849,0,0,1,1.144-.373l6.159,3.143a.849.849,0,0,1,.381,1.125L9.638,33.959a.854.854,0,0,1-.5.438A.873.873,0,0,1,8.871,34.444ZM3.536,29.891l4.947,2.548,6.556-13.675-4.663-2.378Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75405",
    "data-name": "Path 75405",
    d: "M19.942,23.261a.849.849,0,0,1-.417-.11l-2.468-1.39a.849.849,0,1,1,.833-1.48l2.039,1.148c.8-.482,2.518-1.521,3.621-2.144,1.8-1.019,3.067-.879,4.522.5A.849.849,0,1,1,26.9,21.017c-.9-.856-1.374-.9-2.518-.255-1.417.8-3.973,2.359-4,2.378A.849.849,0,0,1,19.942,23.261Z",
    transform: "translate(-2.271 -0.637)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75406",
    "data-name": "Path 75406",
    d: "M43.489,37.935a3.251,3.251,0,0,1-1.76-.465c-.781-.522-4.22-3.894-4.9-4.564A.849.849,0,0,1,38.017,31.7c1.529,1.509,4.152,4.028,4.652,4.362a1.977,1.977,0,0,0,2.008-.207A1.208,1.208,0,0,0,44.643,34c-.868-.977-4.475-4.447-5.266-5.208a56.31,56.31,0,0,1-8.011-3.671l-.894.584a3.892,3.892,0,0,1-1.5,2.32,2.343,2.343,0,0,1-1.935.452,2.952,2.952,0,0,1-2.046-1.227,4.026,4.026,0,0,1-.141-3.072A6.47,6.47,0,0,1,28.372,19.5l.358-.228c1.792-1.151,3.33-1.764,5.019-1,1.05.473,4.776,1.916,5.834,2.326l3.547-1.163a.849.849,0,1,1,.529,1.614L39.825,22.3a.855.855,0,0,1-.569-.014c-.2-.078-4.939-1.9-6.2-2.47-.757-.34-1.556-.3-3.4.883l-.365.234A4.894,4.894,0,0,0,26.5,24.587c-.287,1.148-.155,1.614-.05,1.784.134.224.445.315.94.439a.727.727,0,0,0,.6-.17,2.2,2.2,0,0,0,.862-1.516.849.849,0,0,1,.381-.637l1.635-1.069a.849.849,0,0,1,.872-.032c.058.031,5.784,3.163,8.293,3.822a.865.865,0,0,1,.372.208c.183.176,4.5,4.311,5.516,5.455a2.888,2.888,0,0,1-.034,4.182,3.409,3.409,0,0,1-2.394.883Z",
    transform: "translate(-3.473 -0.533)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75407",
    "data-name": "Path 75407",
    d: "M48.8,36.645a.849.849,0,0,1-.344-1.626l2.98-1.32a.849.849,0,1,1,.688,1.553L49.14,36.576A.849.849,0,0,1,48.8,36.645Z",
    transform: "translate(-6.988 -2.896)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75408",
    "data-name": "Path 75408",
    d: "M50.72,34.444a.849.849,0,0,1-.787-.532L43.521,18.006a.849.849,0,0,1,.5-1.118l6.851-2.451a.849.849,0,0,1,1.075.486L58.234,30.7a.849.849,0,0,1-.485,1.1l-6.726,2.58A.849.849,0,0,1,50.72,34.444Zm-5.3-16.254L51.193,32.5l5.142-1.971L50.674,16.313ZM41.2,39.978a2.876,2.876,0,0,1-1.923-.662c-1.137-1.011-4.061-3.933-4.185-4.057a.849.849,0,1,1,1.2-1.2c.03.03,3.013,3.011,4.112,3.992a1.657,1.657,0,0,0,1.529.1,2.3,2.3,0,0,0,1.532-1.834.849.849,0,0,1,1.674.289A4,4,0,0,1,42.5,39.751a3.953,3.953,0,0,1-1.3.228Z",
    transform: "translate(-5.015 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75409",
    "data-name": "Path 75409",
    d: "M36.806,46.071a2.687,2.687,0,0,1-1.9-.68l-3.017-3.017,1.2-1.2L36.1,44.19a1.529,1.529,0,0,0,1.238.116,2.239,2.239,0,0,0,1.629-1.6.849.849,0,1,1,1.624.5,3.956,3.956,0,0,1-3.788,2.864Z",
    transform: "translate(-4.569 -4.034)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75410",
    "data-name": "Path 75410",
    d: "M33.057,48.892a3.085,3.085,0,0,1-1.927-.624q-1.148-.919-2.306-1.825A.849.849,0,1,1,29.87,45.1s1.061.828,2.322,1.837a1.807,1.807,0,0,0,1.784.037,1.324,1.324,0,0,0,.8-1.268.849.849,0,0,1,.823-.875.86.86,0,0,1,.875.824,3.022,3.022,0,0,1-1.74,2.84,3.789,3.789,0,0,1-1.677.393Z",
    transform: "translate(-4.059 -4.586)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75411",
    "data-name": "Path 75411",
    d: "M25.308,47.453a2.124,2.124,0,0,1-.8-.161,3.751,3.751,0,0,1-1.635-1.561,2.676,2.676,0,0,1-1.769-.266,4.1,4.1,0,0,1-1.772-2.623.849.849,0,0,1,.116-.629c.691-1.077,1.732-2.751,1.887-3.1a2.163,2.163,0,0,1,1.41-1.128,2.852,2.852,0,0,1,2.414.462,2.531,2.531,0,0,1,1.125,2.329,2.828,2.828,0,0,1,2.09,1.063,3.049,3.049,0,0,1,.325,2.605,5.053,5.053,0,0,1-2.548,2.84A2.152,2.152,0,0,1,25.308,47.453ZM24.3,44.8c.267.451.743,1.1,1.189.912a3.354,3.354,0,0,0,1.6-1.817A1.377,1.377,0,0,0,27,42.838a1.346,1.346,0,0,0-.98-.384Zm-3.22-2a2.146,2.146,0,0,0,.83,1.165,1.031,1.031,0,0,0,.818.054l1.813-3.109a.9.9,0,0,0-.35-1.074,1.189,1.189,0,0,0-.934-.239.638.638,0,0,0-.374.206c-.224.5-1.3,2.209-1.8,3Z",
    transform: "translate(-2.675 -3.54)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75412",
    "data-name": "Path 75412",
    d: "M18.248,43.818a2.082,2.082,0,0,1-.595-.085C16.2,43.3,15.629,41.412,15.568,41.2a.849.849,0,0,1,.079-.65,35.233,35.233,0,0,1,2.391-3.618,2.883,2.883,0,0,1,3.817-.685c.8.556,1.39,1.767.406,3.348a.85.85,0,1,1-1.444-.9c.218-.353.408-.821.069-1.056a1.176,1.176,0,0,0-1.5.324,33.492,33.492,0,0,0-2.068,3.092c.186.444.5.953.826,1.049.286.085.68-.209.893-.391A.85.85,0,0,1,20.146,43a2.9,2.9,0,0,1-1.9.816Z",
    transform: "translate(-2.107 -3.225)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75413",
    "data-name": "Path 75413",
    d: "M15.86,41.548a.849.849,0,0,1-.274-.046c-.144-.048-3.529-1.232-3.529-3.883a.86.86,0,0,1,.041-.262,9.928,9.928,0,0,1,1.251-2.378,2.637,2.637,0,0,1,3.268-.632,2.2,2.2,0,0,1,1.189,2.724c-.556,1.789-1.125,3.833-1.131,3.855a.849.849,0,0,1-.818.621Zm-2.1-3.8c.085.8.9,1.4,1.551,1.762.222-.775.55-1.9.873-2.944a.51.51,0,0,0-.319-.7,1.019,1.019,0,0,0-1.129.085,8.8,8.8,0,0,0-.976,1.793Z",
    transform: "translate(-1.583 -2.959)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75414",
    "data-name": "Path 75414",
    d: "M13.331,36.957a.849.849,0,0,1-.479-.149l-2.228-1.529a.85.85,0,1,1,.96-1.4l2.228,1.529a.849.849,0,0,1-.481,1.551Z",
    transform: "translate(-1.311 -2.913)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCard3);
export default __webpack_public_path__ + "static/media/users-card-3.04980f16992917a9d48801244ccdf734.svg";
export { ForwardRef as ReactComponent };